import { createZustandStore } from '../../../zustand';
import { DEFAULT_SCAN_TYPE } from '../remove-package';

import { IMovePackageFromBlackboxStore } from './types';

/**
 * This creates a local global state for Remove Package and update the
 * filters
 */
export const useMovePackageFromBlackboxStore =
  createZustandStore<IMovePackageFromBlackboxStore>()((set) => ({
    blackBoxRemarks: '',
    updateBlackBoxRemarks: (text: string) =>
      set(() => ({ blackBoxRemarks: text })),
    inventoryTransactionId: '',
    updateInventoryTransactionId: (inventoryTransactionId) =>
      set(() => ({ inventoryTransactionId })),
    packageDetails: null,
    updatePackageDetails: (packageDetails) => set(() => ({ packageDetails })),
    transferPodInfo: null,
    updateTransferPodInfo: (transferPodInfo) =>
      set(() => ({ transferPodInfo })),
    transferTrayInfo: null,
    updateTransferTrayInfo: (transferTrayInfo) =>
      set(() => ({ transferTrayInfo })),
    isPackageRemoved: false,
    currentScanStep: 'scanPackage',
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    scanType: DEFAULT_SCAN_TYPE,
    suggestedTrayInfo: null,
    updateSuggestedTrayInfo: (suggestedTrayInfo) =>
      set(() => ({ suggestedTrayInfo })),
    updateScanType: (scanType) => set(() => ({ scanType })),
    isScannerReadingData: false,
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    packageIdentifier: '',
    updatePackageIdentifier: (packageIdentifier) =>
      set(() => ({ packageIdentifier })),
    resetStore: () =>
      set(() => ({
        packageDetails: null,
        transferPodInfo: null,
        transferTrayInfo: null,
        isPackageRemoved: false,
        currentScanStep: 'scanPackage',
        scanType: DEFAULT_SCAN_TYPE,
        isScannerReadingData: false,
        packageIdentifier: '',
      })),
  }));
